export function NotFoundPage() {
  return (
    <section className="not-found">
      <h2>why are you here??</h2>
      <p>
        you appear to be swimmming in <a href="/dev/null">/dev/null</a>. Head back to {' '}
        <a href="/">home</a>.
      </p>
    </section>
  );
}
